<div class="log-cinematic-section-datascript__datascript-log-section">
    <div
        logFieldTitle
        [withMarginTop]="false"
    >
        {{ l10nKeys.datascriptLogLabel | vtranslate }}
    </div>
    <span
        *ngIf="(datascriptInfo$ | async).datascript_log as appDataScriptLog; else connDataScriptLog"
        logPartialSelectionFilter
        property="datascript_log"
        [value]="appDataScriptLog"
        position="right"
        (onFilterAdd)="closeCinematicView()"
    ></span>
</div>

<avi-diff-grid
    [config]="datascriptDiffGridConfig"
    [rows]="diffGridRows"
></avi-diff-grid>

<ng-template #connDataScriptLog>
    <span
        *ngIf="(datascriptInfo$ | async).ds_log as connDataScriptLog; else na"
        logPartialSelectionFilter
        property="ds_log"
        [value]="connDataScriptLog"
        position="right"
        (onFilterAdd)="closeCinematicView()"
    ></span>
</ng-template>

<ng-template #na>
    <span logEmptyField></span>
</ng-template>
